"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationMixin = void 0;
var _styledComponents = require("styled-components");
var _PaginationList = require("../../components/PaginationList/PaginationList.styles");
var _PaginationNumberItem = require("../../components/PaginationNumberItem/PaginationNumberItem.styles");
var _PaginationReadoutItem = require("../../components/PaginationReadoutItem/PaginationReadoutItem.styles");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _spacingMixin = require("../spacingMixin");
var showNumberButtonsCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('showNumberButtons', function (_ref) {
  var showNumberButtons = _ref.showNumberButtons;
  return (0, _styledComponents.css)(["", "{justify-content:", ";}", "{display:", ";}", "{display:", ";}"], _PaginationList.StyledPaginationList, showNumberButtons ? 'center' : 'space-between', _PaginationNumberItem.StyledPaginationNumberItem, showNumberButtons ? 'block' : 'none', _PaginationReadoutItem.StyledPaginationReadoutItem, showNumberButtons ? 'none' : 'block');
});

/** @class PaginationMixin */
/** @method */
var PaginationMixin = function PaginationMixin(props) {
  return (0, _styledComponents.css)(["display:block;margin-left:auto;margin-right:auto;width:100%;user-select:none;", " ", " ", ""], (0, _spacingMixin.spacingMixin)(props), showNumberButtonsCSS(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
    return showNumberButtonsCSS(Object.assign({}, mediaProps));
  }));
};
exports.PaginationMixin = PaginationMixin;